import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'

import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import OutgoingChart from './OutgoingChart/OutgoingChart';
import OutgoingLog from './OutgoingLog/OutgoingLog';
import OutgoingChart2 from './OutgoingChart2/OutgoingChart2';
// import IncomerChart from '../Incomer/IncomerChart/IncomerChart';
// import IncomerLog from '../Incomer/IncomerLog/IncomerLog';



export default function OutgoingTabs({TabTitle,ID}) {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));
   

    const [key, setKey] = useState('Chart1');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        // console.info('You clicked a breadcrumb.');
    }

    // console.log("TabtitleTabs", TabTitle, "ID", ID);

   

    return (
        <Box>
            
            <Box mt={spacing(1)}>
                <Tabs
                    style={{ justifyContent: "flex-start" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    
                    <Tab eventKey="Chart1" title="Chart1">
                    <OutgoingChart  TabTitle={TabTitle} ID={ID}/>
                    </Tab>

                    <Tab eventKey="Chart2" title="Chart2">
                    <OutgoingChart2  TabTitle={TabTitle} ID={ID}/>
                    </Tab>


                
                    <Tab eventKey="Log" title="Log">
                    <OutgoingLog TabTitle={TabTitle} ID={ID}/>
                    </Tab>
                                 
                </Tabs>
            </Box>
        </Box>

    )
}